// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__2OClm","selected":"Tab_selected__1uEcS"};